import { HostActionOnGuestDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
export const showHostActionOnGuestDialog = mountDialogUIReactComponent(HostActionOnGuestDialog);
